
// region JS Imports

// region External Modules
import _compact from "lodash/compact"

import numeral from "numeral"
// endregion External Modules

// region Private Modules
import DataRetriever from "app/data_retriever"

import I18n from "plugins/i18n-js"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface INumberWithCommasAndSuffixOptions {
  use_short_form_for_chinese: boolean,
}
const default_options: INumberWithCommasAndSuffixOptions = {
  use_short_form_for_chinese: true,
}

const default_number_format = "0,0.[00]"
const zh_number_format = "0,0"
const zh_small_number_format = "0,0.[0]"

const Formatter = {
  phoneNumber(value: string, country_code: string): string | null {
    if (value && !value.includes(country_code)){
      return `${country_code}${value.replace(/\s+/g, "")}`
    }

    return value
  },


  // region to be deprecated

  numberWithCommas(value: number | string): string | undefined {
    if ( typeof value === "string" && value.length === 0){
      return
    }
    const parts = value.toString().split(".")
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return parts.join(".")
  },
  numberWithCommasAndSuffix(value: number, options?: INumberWithCommasAndSuffixOptions): string | undefined {
    const opts = Object.assign({}, options, default_options)

    let final_value = value.toString()

    switch (I18n.locale){
      case "zh-TW":
      case "zh-HK":
        if (value >= 100000000 && opts.use_short_form_for_chinese) {
          const value_at_100_000_000 = Math.floor(value / 100000000)
          const value_at_10_000 = Math.round((value - (100000000.0 * value_at_100_000_000)) / 10000)

          return [
            `${value_at_100_000_000}億`,
            (value_at_10_000 > 0) ? `${value_at_10_000}萬` : ``,
          ].join("")
        }

        if (value >= 10000 && opts.use_short_form_for_chinese) {
          final_value = (value / 10000).toFixed(1).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}萬`
        }

        return Formatter.numberWithCommas(final_value)
      case "zh-CN":
        if (value >= 100000000 && opts.use_short_form_for_chinese) {
          const value_at_100_000_000 = Math.floor(value / 100000000)
          const value_at_10_000 = Math.round((value - (100000000.0 * value_at_100_000_000)) / 10000)

          return [
            `${value_at_100_000_000}亿`,
            (value_at_10_000 > 0) ? `${value_at_10_000}万` : ``,
          ].join("")
        }

        if (value >= 10000 && opts.use_short_form_for_chinese) {
          final_value = (value / 10000).toFixed(1).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}万`
        }

        return Formatter.numberWithCommas(final_value)
      default:
        if (value >= 1000000) {
          final_value = (value / 1000000).toFixed(1).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}M`
        }

        if (value >= 1000) {
          final_value = (value / 1000).toFixed(1).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}K`
        }

        return final_value
    }
  },
  numberAlwaysWithCommasAndSuffix(value: number): string | undefined {
    let final_value = value.toString()

    switch (I18n.locale){
      case "zh-TW":
      case "zh-HK":
        if (value >= 100000000) {
          const value_at_100_000_000 = Math.floor(value / 100000000)
          const value_at_10_000 = Math.round((value - (100000000.0 * value_at_100_000_000)) / 10000)

          return [
            `${value_at_100_000_000}億`,
            (value_at_10_000 > 0) ? `${Formatter.numberWithCommas(value_at_10_000)}萬` : "",
          ].join("")
        }

        if (value > 0) {
          final_value = (value / 10000).toFixed(1).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}萬`
        }

        return Formatter.numberWithCommas(final_value)
      case "zh-CN":
        if (value >= 100000000) {
          const value_at_100_000_000 = Math.floor(value / 100000000)
          const value_at_10_000 = Math.round((value - (100000000.0 * value_at_100_000_000)) / 10000)

          return [
            `${value_at_100_000_000}亿`,
            (value_at_10_000 > 0) ? `${Formatter.numberWithCommas(value_at_10_000)}万` : "",
          ].join("")
        }

        if (value > 0) {
          final_value = (value / 10000).toFixed(1).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}万`
        }

        return Formatter.numberWithCommas(final_value)
      default:
        if (value >= 1000000000) {
          final_value = (value / 1000000000).toFixed(2).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}B`
        }

        if (value >= 1000000) {
          final_value = (value / 1000000).toFixed(2).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}M`
        }

        if (value > 0) {
          final_value = (value / 1000).toFixed(2).replace(/\.0$/, "")

          return `${Formatter.numberWithCommas(final_value)}K`
        }

        return final_value
    }
  },

  numberWithoutCommas(value: string | number): number | null {
    if ( typeof value === "string" && value.length === 0){
      return null
    }

    return parseFloat(value.toString().replace(/,/g, ""))
  },

  numberWithCommasAndCurrency(value: string | number, precision = 2) {
    if ( typeof value === "string" && value.length === 0){
      return
    }
    const currency_unit = DataRetriever.get("currency-unit") || "$"
    const number_without_comma = Formatter.numberWithoutCommas(value)
    if ( number_without_comma == null ){ return }
    const sanitized_value = Math.abs(number_without_comma)

    return [currency_unit, Formatter.numberWithCommas(sanitized_value.toFixed(precision))].join("")
  },

  // endregion to be deprecated

  formattedNumberLabelForDisplay(input_hash: {value: number | null, prefix: string | null, use_exact_value: boolean} ) {
    const original_value = input_hash.value
    const prefix = input_hash.prefix
    const use_exact_value = input_hash.use_exact_value

    if ( original_value == null || isNaN(original_value) ) {
      return null
    }
    else if ( original_value === 0 ) {
      return _compact([prefix, "0"]).join("")
    }
    else {
      let formattedNumberString = original_value.toString()
      let rounded_value = original_value

      switch (I18n.locale) {
        case "zh-TW":
        case "zh-HK":
          rounded_value = parseFloat(original_value.toFixed(0))

          if ( use_exact_value ) {
            formattedNumberString = numeral(rounded_value).format(zh_number_format)
          }
          else if ( original_value < 10000 ) {
            formattedNumberString = `${numeral(rounded_value / 10000).format(zh_small_number_format)}萬`
          }
          else if ( Math.round(rounded_value / 10000) * 10000 < 100000000 ) {
            formattedNumberString = `${numeral(rounded_value / 10000).format(zh_number_format)}萬`
          }
          else if ( Math.round(rounded_value / 100000000) * 100000000 < 1000000000000 ) {
            formattedNumberString = `${numeral(rounded_value / 100000000).format(default_number_format)}億`
          }
          else {
            formattedNumberString = `${numeral(rounded_value / 1000000000000).format(default_number_format)}萬億`
          }

          break;

        case "zh-CN":
          if ( use_exact_value ) {
            formattedNumberString = numeral(rounded_value).format(zh_number_format)
          }
          else if ( original_value < 10000 ) {
            formattedNumberString = `${numeral(rounded_value / 10000).format(zh_small_number_format)}万`
          }
          else if ( Math.round(rounded_value / 10000) * 10000 < 100000000 ) {
            formattedNumberString = `${numeral(rounded_value / 10000).format(zh_number_format)}万`
          }
          else if ( Math.round(rounded_value / 100000000) * 100000000 < 1000000000000 ) {
            formattedNumberString = `${numeral(rounded_value / 100000000).format(default_number_format)}亿`
          }
          else {
            formattedNumberString = `${numeral(rounded_value / 1000000000000).format(default_number_format)}万亿`
          }

          break;

        default:
          rounded_value = parseFloat(original_value.toFixed(2))

          if ( use_exact_value ) {
            formattedNumberString = numeral(rounded_value).format(default_number_format)
          }
          else if ( Math.round(rounded_value / 1000) * 1000 < 1000000 ) {
            formattedNumberString = `${numeral(original_value / 1000).format(default_number_format)}K`
          }
          else if ( Math.round(rounded_value / 1000000) * 1000000 < 1000000000 ) {
            formattedNumberString = `${numeral(rounded_value / 1000000).format(default_number_format)}M`
          }
          else if ( Math.round(rounded_value / 1000000000) * 1000000000 < 1000000000000 ) {
            formattedNumberString = `${numeral(rounded_value / 1000000000).format(default_number_format)}B`
          }
          else {
            formattedNumberString = `${numeral(rounded_value / 1000000000000).format(default_number_format)}T`
          }
      }

      return _compact([prefix, formattedNumberString]).join("")
    }
  },
}

export default Formatter
